import { ENV } from "../utils/envReader.util";
import "./kontakt.page.css";
import Mail from "../assets/mail_logo.png";
import Phone from "../assets/phone.png";
import Position from "../assets/position.png";
import Email from "../assets/emailsymbol.png";
import LanguageButton from "../components/languageButton.component";

function Kontakt(
    props: Readonly<{
        isEnglish: boolean;
        setIsEnglish: (newValue: boolean) => void;
    }>
) {
    const { isEnglish, setIsEnglish } = props;
    
    return (
        <div id="kontakt" className="standard-page">
            <div className="flex gap items-center mt-5 mb-3">
                <h5>{isEnglish ? "Contact" : "Kontakt"}</h5>
                <LanguageButton onToggle={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />
            </div>

            <div className="box flex column gap-2">
                <div className="flex gap">
                    <img src={Email} alt="mail" width="20px" height="20px" />
                    <a href={`mailto:${ENV.MAIL}`}><p>{ENV.MAIL}</p></a>
                </div>

                <div className="flex gap">
                    <img src={Phone} alt="phone" width="20px" height="20px" />
                    <a href={`tel:${ENV.NUMBER}`}><p>{ENV.NUMBER}</p></a>
                </div>

                <div className="flex gap">
                    <img src={Mail} alt="position" width="20px" height="20px" />
                    <div>
                        <p style={{color: "var(--color-green)"}}>{isEnglish ? "Mailing address" : "Postanschrift"}</p>
                        <p>{ENV.ADR_NAME}</p>
                        <p>{ENV.ADR_STREET}</p>
                        <p>{ENV.ADR_CITY}</p>
                        <p>{ENV.ADR_COUNTRY}</p>
                    </div>
                </div>

                <div className="flex gap">
                    <img src={Position} alt="position" width="20px" height="20px" />
                    <div>
                        <p style={{color: "var(--color-green)"}}>{isEnglish ? "Visitor address" : "Besucheradresse"}</p>
                        <p>{ENV.ADR_B_NAME}</p>
                        <p>{ENV.ADR_B_STREET}</p>
                        <p>{ENV.ADR_B_CITY}</p>
                        <p>{ENV.ADR_B_COUNTRY}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Kontakt;